<script setup>

import {ref} from "vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
const search = ref('');
const emit = defineEmits(['submit']);


const submit = () => {
    if (search.value !== '') {
        emit('submit', search.value)
    }
}
</script>

<template>
    <header id="search_container">
        <label>
            <input name="speakers" :placeholder="t('Buscar por palestrante')" v-model="search">
        </label>
        <button type="button" @click="$emit('submit', search)">{{t('Buscar')}}</button>
    </header>
</template>

<style scoped>

</style>
